export const QUESTIONS = [
  // ── Phase 1: Industry ──────────────────────────────────────────────
  {
    id: "q1",
    phase: "industry",
    phaseLabel: "Industry",
    question: "What industry does your organization operate in?",
    type: "mcq",
    options: ["Healthcare & Wellness", "Retail & E-commerce", "Manufacturing & Distribution", "Financial Services"],
    allowOther: true,
    progress: { current: 1, total: 5 },
  },

  // ── Phase 2: Company Size ──────────────────────────────────────────
  {
    id: "q2",
    phase: "size",
    phaseLabel: "Company Size",
    question: "How many full-time employees does your company have?",
    type: "mcq",
    options: ["1 – 10", "11 – 50", "51 – 200", "200+"],
    allowOther: false,
    progress: { current: 2, total: 5 },
  },
  {
    id: "q3",
    phase: "size",
    phaseLabel: "Company Size",
    question: "What is your approximate annual revenue?",
    type: "mcq",
    options: ["Under $500K", "$500K – $2M", "$2M – $10M", "Over $10M"],
    allowOther: false,
    progress: { current: 3, total: 5 },
  },
  {
    id: "q4",
    phase: "size",
    phaseLabel: "Company Size",
    question: "List your main departments (e.g. Sales, HR, Finance, Operations)",
    type: "freetext",
    options: [],
    allowOther: false,
    hint: "Separate with commas — even a rough list is fine.",
    progress: { current: 4, total: 5 },
  },
  {
    id: "q5",
    phase: "size",
    phaseLabel: "Company Size",
    question: "How would you describe your current technology infrastructure?",
    type: "mcq",
    options: ["Mostly manual / spreadsheets", "Basic off-the-shelf software", "Dedicated ERP or CRM system", "Custom enterprise systems"],
    allowOther: true,
    progress: { current: 5, total: 5 },
  },
]
